import React from 'react';
import * as html from '../../util/html';
require('./RowButtons.scss');

export default class RowButtons extends React.Component {
	constructor(props) {
		super(props);
		this.touchTapHandler = this.touchTapHandler.bind(this);
		this.state = {
			cls: 'statusIcon'
		};
	}

	touchTapHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		this.props.onTouchTap && this.props.onTouchTap();
	}

	render() {
        const { buttonId = '', partId = '', cls, text } = this.props;
        // 涉及到udc均为行为埋点数据，具体访问https://wiki.beisen.co/pages/viewpage.action?pageId=40337516
        const udc = {
            ext: {
            	type: 'cloudButton',
	            id: buttonId,
	            partId
	        }
        };
		return (
            <span data-udc={encodeURIComponent(JSON.stringify(udc))} className={this.state.cls + ' ' + cls} onTouchTap={this.touchTapHandler}>{html.decode(text)}</span>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TableColumns/RowButtons/RowButtons.js